import type { DispersionErrorKind } from "../hooks/useSubmitDispersion";
import { PaymentsQuotesService } from "../services/paymentsQuotes.service";

/**
 * Asks the quote whether it was actually spent, instead of guessing from the 409.
 *
 * `GET /quotes/:id` derives `CONSUMED` from `consumed_at`, so it is the one signal that is both authoritative
 * and independent of the response language. Reading it AFTER the failure is not a race — the quote is already
 * in a terminal state by then; it would only have been one before the POST.
 *
 * A failed read is deliberately NOT treated as "fine". When money might have moved, the safe assumption is
 * that it did.
 */
export async function classifyQuoteConflict(
  quoteId: string,
  organizationId: string | undefined,
): Promise<DispersionErrorKind> {
  try {
    const { data } = await PaymentsQuotesService.getQuote(quoteId, organizationId);
    return data.quote.status === "CONSUMED" ? "quote_consumed" : "generic";
  } catch {
    return "unconfirmed";
  }
}
